import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import Modal from "../../../components/base/Modal";
import ToggleSwitch from "../../../components/form/ToggleSwitch";
import { API_ROUTES } from "../../../core/Constants";
import { toPrettyDate, updateUsersOn, useHub } from "../../../core/Global";
import User from "../models/User";


interface IProps {
    user: User
    onClose: () => void
}

export default function CustomersCancelModal(props: IProps) {

    const hub = useHub();



    return (
        <Modal id="customers-cancel-modal"
            title="Cancel Subscription"
            open visible
            onClose={props.onClose}
            buttonText="Cancel Subscription"
            buttonColor="danger"
            onSubmit={(body, callback) => {

                hub.Post(API_ROUTES.Customers + "cancelsub", {
                    ...body,
                    id: props.user.id
                }, res => {
                    callback!(res);
                    updateUsersOn();
                })

            }}>
            <div>
                <FlexRow className="mb-2">
                    <Icon icon="user" type="solid" className="me-4" size={18} />
                    <span className="fs-3 mt-1">{props.user.fullName}</span>
                </FlexRow>
                <FlexRow className="mb-10">
                    <Icon icon="calendar-times" type="solid" className="me-4" size={18} />
                    <span className="fs-3 mt-1">{toPrettyDate(props.user.subscription?.endsAt)}</span>
                </FlexRow>

                <div>
                    Are you sure you want to cancel the subscription?
                </div>

            </div>
        </Modal>
    )
}